import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

export default function CustomerSelectionPage() {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    // Verhindere Scrolling komplett auf dieser Seite
    document.body.style.overflow = 'hidden';
    document.body.style.height = '100vh';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '0';
    document.body.style.left = '0';
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.height = '100vh';

    // Blockiere alle Scroll-Events
    const preventScroll = (e) => {
      e.preventDefault();
      e.stopPropagation();
      return false;
    };

    const options = { passive: false, capture: true };
    const wheelHandler = (e) => preventScroll(e);
    const touchHandler = (e) => preventScroll(e);
    const scrollHandler = (e) => preventScroll(e);
    const keyHandler = (e) => {
      if ([32, 33, 34, 35, 36, 37, 38, 39, 40].includes(e.keyCode)) {
        preventScroll(e);
      }
    };

    document.addEventListener('wheel', wheelHandler, options);
    document.addEventListener('touchmove', touchHandler, options);
    document.addEventListener('scroll', scrollHandler, options);
    document.addEventListener('keydown', keyHandler, options);
    window.addEventListener('wheel', wheelHandler, options);
    window.addEventListener('touchmove', touchHandler, options);
    window.addEventListener('scroll', scrollHandler, options);

    return () => {
      document.removeEventListener('wheel', wheelHandler, options);
      document.removeEventListener('touchmove', touchHandler, options);
      document.removeEventListener('scroll', scrollHandler, options);
      document.removeEventListener('keydown', keyHandler, options);
      window.removeEventListener('wheel', wheelHandler, options);
      window.removeEventListener('touchmove', touchHandler, options);
      window.removeEventListener('scroll', scrollHandler, options);
    };
  }, []);

  const handleSelect = (type) => {
    // Speichere die Auswahl
    localStorage.setItem("customerType", type);
    // Erlaube Scrolling wieder
    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    // Weiterleiten zur entsprechenden Seite
    if (type === "private") {
      navigate("/privatkunden", { replace: true });
    } else if (type === "business") {
      navigate("/geschaeftskunden", { replace: true });
    }
  };

  return (
    <div className="fixed inset-0 h-screen w-screen overflow-hidden" style={{ height: '100vh', width: '100vw' }}>
      {/* Hero-Bereich mit Hintergrundbild - identisch zur HomePage */}
      <section
        className="relative h-full w-full bg-cover bg-center"
        style={{ backgroundImage: "url('/hero3.jpg')" }}
      >
        {/* Overlay - identisch zur HomePage */}
        <div className="absolute inset-0 bg-black bg-opacity-50 text-white text-center px-4">
          {/* Logo ganz oben - fixed height container to prevent layout shift */}
          <div className="flex flex-col items-center pt-6 relative" style={{ minHeight: '180px' }}>
            <img src="/imenso-logo-trans.png" alt="IMENSO Logo" className="h-24 md:h-32 mb-2" />
            
            {/* Burger Menu - direkt unter dem Logo */}
            <button
              onClick={() => setMenuOpen(!menuOpen)}
              className="p-2 rounded-md hover:bg-white hover:bg-opacity-20 transition-colors"
              aria-label="Menu"
            >
              {menuOpen ? (
                <X className="w-6 h-6 text-white" />
              ) : (
                <Menu className="w-6 h-6 text-white" />
              )}
            </button>
            
            {/* Dropdown Menu - absolutely positioned to prevent layout shift */}
            {menuOpen && (
              <div className="absolute top-full mt-2 left-1/2 transform -translate-x-1/2 bg-transparent rounded-lg shadow-lg min-w-[200px] z-50">
                <nav className="flex flex-col py-2">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSelect("private");
                      setMenuOpen(false);
                    }}
                    className="px-6 py-3 text-white hover:bg-white hover:bg-opacity-20 transition-colors"
                  >
                    Privatkunden
                  </a>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      handleSelect("business");
                      setMenuOpen(false);
                    }}
                    className="px-6 py-3 text-white hover:bg-white hover:bg-opacity-20 transition-colors"
                  >
                    Geschäftskunden
                  </a>
                </nav>
              </div>
            )}
          </div>

          {/* Texte zentriert in der Mitte */}
          <div className="flex flex-col items-center justify-center min-h-[calc(100dvh-6rem)] mt-4">
            <h1 className="text-3xl md:text-5xl font-semibold mb-4">
              Willkommen bei IMENSO
            </h1>
            <p className="text-xl md:text-2xl text-gray-200">
              Bitte wählen Sie im Menü oben
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
